/**
 * BYD Gear Pro - Shopify Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {

  /* =========== Mobile Menu =========== */
  var mobileToggle = document.querySelector('.header__mobile-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      var icon = mobileToggle.querySelector('.header__icon-text') || mobileToggle;
      icon.textContent = mobileMenu.classList.contains('active') ? '✕' : '☰';
    });
  }

  /* =========== Cart Drawer =========== */
  var cartOpen = document.querySelector('.header__icon--cart');
  var floatingCartOpen = document.querySelector('.floating-cart-bar__link');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');
  var cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    updateCartCounts();
    updateCartDrawer();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function syncOverlayAndCloseBindings() {
    cartOverlay = document.querySelector('.cart-drawer__overlay');
    cartClose = document.querySelector('.cart-drawer__close');

    if (cartOverlay) {
      cartOverlay.onclick = function(e) {
        e.preventDefault();
        closeCart();
      };
    }

    if (cartClose) {
      cartClose.onclick = function(e) {
        e.preventDefault();
        closeCart();
      };
    }
  }

  if (cartOpen) cartOpen.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  if (floatingCartOpen) floatingCartOpen.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  syncOverlayAndCloseBindings();

  /* =========== Cart Drawer Logic (AJAX Updates) =========== */
  var isUpdatingCart = false;

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function updateCartDrawer() {
    if (isUpdatingCart) return;
    isUpdatingCart = true;

    console.log('Fetching updated Cart Drawer...');
    var cartItemsContainer = document.querySelector('.cart-drawer__items');
    if (cartItemsContainer) cartItemsContainer.style.opacity = '0.5';

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js?ts=' + Date.now())
      .then(res => res.json())
      .then(cart => {
        if (!cartDrawer) return;

        var itemsHtml = '';
        if (cart.items && cart.items.length) {
          itemsHtml = cart.items.map(function(item) {
            var imageHtml = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || 'Product') + '" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">' : '';
            var unitPrice = typeof item.final_price === 'number' ? item.final_price : item.price;
            var money = (unitPrice / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD' });

            return '<div class="cart-drawer__item" data-item-key="' + item.key + '">' +
              '<div class="cart-drawer__item-image">' + imageHtml + '</div>' +
              '<div style="flex:1;">' +
                '<div class="cart-drawer__item-title">' + (item.product_title || '') + '</div>' +
                '<div class="cart-drawer__item-price" style="margin-bottom:8px;">' + money + '</div>' +
                '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                  '<div style="display:flex;align-items:center;border:1px solid var(--color-border,#E5E7EB);border-radius:6px;overflow:hidden;">' +
                    '<button type="button" class="cart-drawer__qty-btn minus" style="width:28px;height:28px;background:#f9fafb;border:none;cursor:pointer;">-</button>' +
                    '<input type="number" class="cart-drawer__qty-input" value="' + item.quantity + '" min="0" style="width:40px;height:28px;text-align:center;border:none;border-left:1px solid var(--color-border);border-right:1px solid var(--color-border);font-size:13px;">' +
                    '<button type="button" class="cart-drawer__qty-btn plus" style="width:28px;height:28px;background:#f9fafb;border:none;cursor:pointer;">+</button>' +
                  '</div>' +
                  '<button type="button" class="cart-drawer__item-remove" style="color:var(--color-red);font-size:12px;background:none;border:none;cursor:pointer;text-decoration:underline;">Remove</button>' +
                '</div>' +
              '</div>' +
            '</div>';
          }).join('');
        } else {
          itemsHtml = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
        }

        var subtotalMoney = (cart.total_price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD' });

        cartDrawer.innerHTML = '' +
          '<div class="cart-drawer__header">' +
            '<h3 class="cart-drawer__title">Your Cart</h3>' +
            '<button class="cart-drawer__close" aria-label="Close cart">✕</button>' +
          '</div>' +
          '<div class="cart-drawer__items">' + itemsHtml + '</div>' +
          (cart.items && cart.items.length ?
            '<div class="cart-drawer__footer">' +
              '<div class="cart-drawer__subtotal">' +
                '<span class="cart-drawer__subtotal-label">Subtotal</span>' +
                '<span class="cart-drawer__subtotal-value">' + subtotalMoney + '</span>' +
              '</div>' +
              '<a href="/checkout" class="cart-drawer__checkout">Checkout</a>' +
            '</div>' : '');

        bindCartDrawerEvents();
        syncOverlayAndCloseBindings();
        updateCartCounts();
      })
      .catch(err => console.error('Error updating cart:', err))
      .finally(() => {
        isUpdatingCart = false;
        if (cartItemsContainer) cartItemsContainer.style.opacity = '1';
      });
  }

  function bindCartDrawerEvents() {
    // 重新绑定关闭按钮
    var closeBtn = cartDrawer.querySelector('.cart-drawer__close');
    if (closeBtn) {
      closeBtn.onclick = function(e) { e.preventDefault(); closeCart(); };
    }

    // 数量增减按钮 - 使用事件委托或直接绑定（因 HTML 已被替换）
    cartDrawer.querySelectorAll('.cart-drawer__qty-btn').forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        if (isUpdatingCart) return;

        var itemElement = this.closest('.cart-drawer__item');
        var itemKey = itemElement.dataset.itemKey;
        var input = itemElement.querySelector('.cart-drawer__qty-input');
        var currentQty = parseInt(input.value);
        var newQty = this.classList.contains('plus') ? currentQty + 1 : currentQty - 1;
        
        if (newQty >= 0) {
          input.value = newQty;
          debouncedUpdateQuantity(itemKey, newQty);
        }
      };
    });

    // 数量输入框
    cartDrawer.querySelectorAll('.cart-drawer__qty-input').forEach(input => {
      input.onchange = function() {
        if (isUpdatingCart) return;
        var itemKey = this.closest('.cart-drawer__item').dataset.itemKey;
        var newQty = parseInt(this.value);
        if (newQty >= 0) {
          debouncedUpdateQuantity(itemKey, newQty);
        }
      };
    });

    // 移除商品
    cartDrawer.querySelectorAll('.cart-drawer__item-remove').forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        if (isUpdatingCart) return;

        var itemElement = this.closest('.cart-drawer__item');
        var itemKey = itemElement.dataset.itemKey;
        
        itemElement.style.opacity = '0.3';
        updateItemQuantity(itemKey, 0);
      };
    });
  }

  var debouncedUpdateQuantity = debounce(function(key, qty) {
    updateItemQuantity(key, qty);
  }, 300);

  function updateItemQuantity(key, qty) {
    if (isUpdatingCart) return;
    isUpdatingCart = true;

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(res => res.json())
    .then(cart => {
      updateCartCounts();
      // 这里必须重新 fetch sections 以更新金额和 HTML 结构
      isUpdatingCart = false; // 先解锁以便 updateCartDrawer 能运行
      updateCartDrawer();
    })
    .catch(error => {
      console.error('Error:', error);
      isUpdatingCart = false;
    });
  }

  // Initial binding
  if (cartDrawer) bindCartDrawerEvents();

  /* =========== FAQ Accordion =========== */
  var faqQuestions = document.querySelectorAll('.faq__question');
  faqQuestions.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = this.nextElementSibling;
      var isOpen = answer.classList.contains('open');

      /* Close all others */
      document.querySelectorAll('.faq__answer.open').forEach(function(a){ a.classList.remove('open'); });
      document.querySelectorAll('.faq__question').forEach(function(q){ q.setAttribute('aria-expanded','false'); });

      if (!isOpen) {
        answer.classList.add('open');
        this.setAttribute('aria-expanded','true');
      }
    });
  });

  /* =========== Search Toggle =========== */
  var searchToggle = document.querySelector('.header__icon--search');
  var searchForm = document.querySelector('.header__search-form');
  var searchInput = document.querySelector('.header__search-input');
  
  if (searchToggle && searchForm) {
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      searchForm.classList.toggle('active');
      if (searchForm.classList.contains('active')) {
        searchInput.focus();
      }
    });

    // 点击外部关闭搜索框
    document.addEventListener('click', function(e) {
      if (!searchForm.contains(e.target) && !searchToggle.contains(e.target)) {
        searchForm.classList.remove('active');
      }
    });
  }

  /* =========== Quantity Selector (product page) =========== */
  var qtyBtn = document.querySelectorAll('.qty-btn');
  qtyBtn.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.qty-input');
      var val = parseInt(input.value) || 1;
      if (this.classList.contains('qty-plus')) {
        input.value = val + 1;
      } else if (val > 1) {
        input.value = val - 1;
      }
    });
  });

  /* =========== Product Gallery Thumbnails =========== */
  var galleryThumbs = document.querySelectorAll('.product-gallery__thumb');
  var galleryMainImages = document.querySelectorAll('.product-gallery__main-image');

  galleryThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var index = this.getAttribute('data-thumb-index');

      galleryThumbs.forEach(function(t) { t.classList.remove('active'); });
      galleryMainImages.forEach(function(img) { img.classList.remove('active'); });

      this.classList.add('active');

      var mainImage = document.querySelector('.product-gallery__main-image[data-image-index="' + index + '"]');
      if (mainImage) mainImage.classList.add('active');
    });
  });

  /* =========== Product Tabs =========== */
  var tabBtns = document.querySelectorAll('.product-tabs__btn');
  var tabPanels = document.querySelectorAll('.product-tabs__panel');

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tabId = this.getAttribute('data-tab');

      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      tabPanels.forEach(function(p) { p.classList.remove('active'); });

      this.classList.add('active');

      var panel = document.getElementById('tab-' + tabId);
      if (panel) panel.classList.add('active');
    });
  });

  /* =========== Sync Floating Cart Count =========== */
  var floatingCartCount = document.querySelector('.floating-cart-bar__count');
  var headerCartCount = document.querySelector('.cart__count');

  if (floatingCartCount && headerCartCount) {
    floatingCartCount.textContent = headerCartCount.textContent;
  }

  /* =========== AJAX Add to Cart =========== */
  function handleAddToCart(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var originalText = '';
      
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('adding');
        originalText = submitBtn.innerHTML;
        if (form.classList.contains('product-card__add-form')) {
          submitBtn.innerHTML = '...';
        } else {
          submitBtn.innerHTML = '<span class="spinner"></span> Adding...';
        }
      }

      var formData = new FormData(form);
      
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(data => {
        // Success state
        if (submitBtn) {
          submitBtn.classList.remove('adding');
          submitBtn.classList.add('added');
          submitBtn.innerHTML = '✓';
          
          setTimeout(() => {
            submitBtn.classList.remove('added');
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }

        // Refresh cart and open drawer
        updateCartCounts().finally(function() {
          updateCartDrawer();
          setTimeout(openCart, 120);
        });
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('adding');
          submitBtn.innerHTML = originalText;
          alert(error.description || 'Error adding to cart. Please try again.');
        }
      });
    });
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    handleAddToCart(form);
  });

  function updateCartCounts() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        console.log('Updating all cart counts to:', cart.item_count);
        var counts = document.querySelectorAll('[data-cart-count]');
        counts.forEach(el => {
          el.textContent = cart.item_count;
          // Ensure it's visible if there are items
          if (el.classList.contains('cart__count')) {
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
        });
      })
      .catch(function(err) {
        console.error('Error updating cart counts:', err);
      });
  }

});
